export const editformReplacementMixin = {
    inject: ['getCSSClass', 'loadingIndicator', 'icon', 'locale', 'translate'],
    props: {
        dataUrl: {type: String},
        saveUrl: {type: String},
        ajaxOperationsUrl: {type: String, default: ''},
        buttons: {},
    },
    methods: {
        emitAndResetComponent(payload) {
            this.$emit(payload);
            this.$emit('component', {subComponents: {'editFormComponent': 'reset'}});
        },
    }
}